export default {
  name: "ProjectsArchived",
  path: "archived",
  component: () => import("@/views/ProjectsArchived")
};
